// src/pages/TherapistPage/CaseHistory/signOffApi.js
import api from '../../../services/api';

export const getSignOffState = (caseId) => api.get(`/case-history/cases/${caseId}/sign-off`);
export const signOffCase = (caseId, note) =>
    api.post(`/case-history/cases/${caseId}/sign-off`, { note: note || null });
export const getSnapshot = (caseId) => api.get(`/case-history/cases/${caseId}/snapshot`);

export const signOffError = (err, fallback = 'Something went wrong. Try again.') =>
    err?.response?.data?.detail || fallback;
